module.exports = {
      id: "logo-usage",
      viewBox: "0 0 997.64 195.19",
      url: __webpack_public_path__ + "svg-sprite-4990048fd6d3fd501089a0638bd441f8.svg#logo",
      toString: function () {
        return this.url;
      }
    }